import { html } from "../lib/bind";

export type ReportsSubNavActive = "pl" | "aging" | "income-by-client";

const ITEMS: { key: ReportsSubNavActive; path: string; label: string }[] = [
  { key: "pl", path: "/reports", label: "Profit & Loss" },
  { key: "aging", path: "/reports/aging", label: "Aging" },
  { key: "income-by-client", path: "/reports/income-by-client", label: "Income by Client" },
];

/** Shared sub-nav for the 3 Reports pages (Phase 6, mirroring banking-subnav.ts's
 * pattern from Phase 5e) — each page's header shows buttons for the other 2. No text
 * label alongside: the topbar already carries "Reports" for every /reports* path
 * (shell.ts's prefix-match active-nav-label). */
export function buildReportsSubNav(active: ReportsSubNavActive): Node {
  const fragment = html`<div class="page-header">
    <div class="invoice-actions"></div>
  </div>`;
  const actions = fragment.querySelector(".invoice-actions");
  if (!actions) throw new Error("reports subnav produced no element");
  for (const item of ITEMS) {
    if (item.key === active) continue;
    const link = document.createElement("a");
    link.href = item.path;
    link.dataset.link = "";
    link.className = "btn";
    link.textContent = item.label;
    actions.appendChild(link);
  }
  return fragment;
}
